import React from 'react';
import SubscriptionPage from '@/components/monetization/SubscriptionPage';

export default function Subscription() {
  return <SubscriptionPage />;
}
